import React, {useContext} from "react";
import {GlobalContext} from "../../context/GlobalContext";
import {getEntityUrl} from "../../util";
import {Link} from "gatsby";
import {classes} from "../../modules/base/classes";
import {findListItemRole} from "../../repository/EntityRepository";
import {ArrowForward} from "@mui/icons-material";
import './nextLinks.css'

const positionToNumber = (position) => {
    switch (position) {
        case 'first':
            return 0;
        case undefined:
        case null:
        case 'second':
            return 1;
        case 'third':
            return 2;
        default:
            return position;
    }
}

export function NextLinks({relations, originalLocale, defaultLocale, onlyRenderIfMatchesPosition}) {
    const {entityRepository} = useContext(GlobalContext);

    return relations?.filter(component => component.strapi_component === "reference-meta.links").map(component => {
        return component.nextLinks.map(link => {
            if (onlyRenderIfMatchesPosition === undefined || positionToNumber(component.position) === onlyRenderIfMatchesPosition) {
                const entity = entityRepository.findByIdentifier(link.identifier, originalLocale, defaultLocale)
                const listRole = findListItemRole(entity)
                const title1 = listRole?.line1 || entity?.title || '';
                const title2 = listRole?.line2 || false;
                const title3 = listRole?.line3 || false

                return (
                    <div className={"list-item next-link"} key={entity.id}>
                        <Link to={getEntityUrl({entity, defaultLocale})} className={classes.listLink}>
                            <div className={classes.listItem}>
                                <ArrowForward/>
                                <div className={classes.titleFlex}>
                                    <div className={classes.titleDiv + " list-item-title"}>
                                        <div className={classes.title1 + " searchable"}>{title1}</div>
                                        <div className={classes.title2 + " searchable"}>{title2}</div>
                                        <div className={classes.title3 + " searchable"}>{title3}</div>
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                )
            }
        })
    }) || null
}
